<template>
  <div class="modal">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="top">
        <div class="title"><strong>Grupos</strong></div>
        <div class="subTitle">Quantidade: {{ props.item.length }}</div>
        <div class="close" @click="emits('close')">X</div>
      </div>
      <div class="content">
        <div class="boxLine" v-for="(g, index) in props.item" :key="index">
          <div
            class="icon"
            :style="{
              backgroundImage:
                'url(https://habblet.city/habblet-imaging/badge/' + g.badgeCode + ')',
            }"
          ></div>
          <div class="flex">
            <div>
              <div class="text">{{ g.name }}</div>
              <div class="text">{{ g.description }}</div>
            </div>
            <div class="boxInfo">
              <div class="info">
                ID do quarto: <a class="black block hover:text-blue-900" :href="`https://www.habblet.city/room/${g.roomId}`" target="_blank">{{ g.roomId }}</a>
              </div>
              <!--              <div class="info">Dono: <span>{{ g.owner }}</span></div>-->
              <!--              <div class="info">Membro: <span>{{ g.level }}</span></div>-->
              <!--              <div class="info">Entrou em: <span>{{ new Date(g.joined * 1000).toLocaleDateString() }}</span></div>-->
              <!--              <div class="info">Grupo criado em: <span>{{ new Date(g.created * 1000).toLocaleDateString() }}</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['close'])
const props = defineProps({
  item: Object,
})
</script>

<style scoped>
.modal .box {
  width: 600px;
}

.modal .top {
  height: 70px;
}

.modal .subTitle {
  margin-left: 10px;
}

.modal .content {
  width: calc(100% - 10px);
  height: 400px;
  overflow: auto;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  box-shadow: none;
  border-radius: 12px;
  margin: 0 0 0 5px;
  padding: 4px;
}

.modal .content::-webkit-scrollbar {
  width: 5px;
}

/*noinspection ALL*/
.modal .content::-webkit-scrollbar-thumb {
  background-color: var(--color2);
  border-radius: 10px;
}

.modal .content .boxLine {
  width: 100%;
  height: auto;
  padding: 10px;
  background-color: #f1f1f1;
  border-radius: 4px;
  margin-top: 6px;
  display: flex;
  justify-content: space-around;
  transition: all 0.3s ease;
}

.modal .content .boxLine:hover {
  background-color: var(--color1);
  border-color: transparent;
  color: #fff;
}

.modal .content .boxLine .icon {
  position: relative;
  width: 60px;
  height: 60px;
  top: 50%;
  transform: translateY(-50%);
  background-position: center;
  background-repeat: no-repeat;
}

.modal .content .boxLine .flex {
  width: 84%;
  display: flex;
  justify-content: space-between;
}

.modal .content .boxLine .flex div:first-of-type {
  width: 70%;
}

.modal .content .boxLine .flex .text {
  width: 100%;
  height: auto;
  padding: 4px 0;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
}

.modal .content .boxLine .flex .text:last-of-type {
  font-size: 13px;
  font-weight: 400;
}

.modal .content .boxLine .flex .info {
  font-size: 12px;
  margin-top: 2px;
}

.modal .content .boxLine .flex .info span {
  font-weight: 600;
}
</style>
